import Vue from "vue";
import ContentElement from "../models/contentManagement/contentElement";
import routes from "../../formability/listViewBuilder/routes/routes";
import {BuilderArea} from "../../formability/listViewBuilder/enums/builder-area";
import ElementHandler from "~/services/elementHandler";
import {certificateElementType} from "~/enums/certificateElementType";

export default class CertificateElementHandler extends ElementHandler {


  append(type: number | string, position: number = null, json: object = {}): ContentElement {
    position = position === 0 || !!position ? position : this.positionWithinSectionIfNonePassedIn
    const element = super.append(type, position, json);
    this.updateElementPositions(this.model, element, position)
    return element
  }

  appendInsertElement(type: number | string, position: number = null, json: object = {}): ContentElement {
    position = position === 0 || !!position ? position : this.positionValueIfNonePassedIn
    if (this.model.type === certificateElementType.Stack && (this.model.isFull || this.model.certificateElementsArray[position]?.isFull)) {
      this.model.addGridCellAtIndex(position)
    }else if(this.model.type === certificateElementType.Grid && this.model.isFull){
      this.model.addRow()
    }
    const element = this.model.firstEmptyCell.elementHandler.append(type, position, json)
    if (this.model.type === certificateElementType.Stack) {
      this.model.cleanUpEmptyCells()
      if (this.model.isFull) {
        this.model.appendGridCell()
      }
    }
    return element
  }

  create(parent, type: number | string, position: number, json: object = {}, selectItem: boolean=true) {
    json['sort_order'] = position;
    json['type'] = type;
    const element: ContentElement = this.model.rootModel.createEmbeddedObject[this.collectionKey](this, json);
    element.initialize(this.model.rootModel, parent, type, json);
    element.initializeAfterParentSet();
    if (typeof this.model.initializeEmbedded === 'function') {
      this.model.initializeEmbedded(parent, element, position, json, selectItem);
    }
    Vue.set(parent[this.collectionKey], element.client_id, element);
    if (!element.hasChanged) {
      // only track create specially if changes haven't already been made through initializing
      parent.trackCreationDeletion(element.client_id, null, element.asJson(), element);
    }
    this.model.rootModel.saveChangesToStore({
      modelId: element.client_id,
      area: routes.find(r => r.name === BuilderArea.layout).path + `?selectedId=${element.client_id}`
    });
    Vue.nextTick(()=>{
      element.select()
    })
    return element;
  }

  move(elementId: string, parentId: string, newPosition: number): void {
    const element = this.model.rootModel.findElement(elementId)
    const newParent = this.model.rootModel.findElement(parentId)

    const oldParent = element.parent;

    if (newParent === oldParent) {
      element.sort_order = newPosition;  // same parent
    } else {
      oldParent.trackCreationDeletion(element.client_id, element.asJson(), null, element);

      element.sort_order = newPosition;
      newParent.trackCreationDeletion(element.client_id, null, element.asJson(), element);
    }
    this.updateElementPositions(newParent, element, newPosition);

    if (newParent !== oldParent) {
      Vue.delete(oldParent[element.rootName], element.client_id);
      element.parent = newParent;
      Vue.set(newParent[element.rootName], element.client_id, element);
    }

    if (oldParent.type === certificateElementType.Stack){
      oldParent.cleanUpEmptyCells()
    }

    this.model.rootModel.saveChangesToStore();
  }

  moveToCell(elementId, containerElementId, newPosition) {
    const containerElement =  this.model.rootModel.findElement(containerElementId)
    const element = this.model.rootModel.findElement(elementId)
    const elementGridCell = element.parent
    const gridCellAtTarget = containerElement.certificateElementsArray[newPosition]
    elementGridCell.trackCreationDeletion(element.client_id, element.asJson(), null, element);
    gridCellAtTarget.trackCreationDeletion(element.client_id, null, element.asJson(), element);
    Vue.delete(elementGridCell[element.rootName], element.client_id);
    element.parent = gridCellAtTarget;
    Vue.set(gridCellAtTarget[element.rootName], element.client_id, element);
    this.model.rootModel.saveChangesToStore();
  }


  createForParentId(parentId: string, type: number | string, position: number, json: object = {}) {
    const parent = this.model.rootModel.findElement(parentId);
    if(parent.type === certificateElementType.Stack){
      const newGridCell = parent.addGridCellAtIndex(position)
      this.createForParentId(newGridCell.client_id, type, position, json)
    }
    else if (parent.type === certificateElementType.GridCell && parent.isFull && parent.layoutElementContainer?.type === certificateElementType.Stack){
      const layoutElementContainer = parent.layoutElementContainer
      const newGridIndex = position + parent.sort_order
      const newGridCell = layoutElementContainer.addGridCellAtIndex(newGridIndex)
      this.createForParentId(newGridCell.client_id, type, 0, json)
    }else{
      const element = this.create(parent, type, position, json);
      element.repo.add(element);
      element.select();
      return element;
    }

  }


  //Called in the case of an element being clicked rather than dragged and dropped
  protected get positionWithinSectionIfNonePassedIn(): number{
    //Either is added after the selected layout element or after section
    return this.model.rootModel.selectedElementsLayoutElement?.sort_order === 0 || !!this.model.rootModel.selectedElementsLayoutElement?.sort_order ? this.model.rootModel.selectedElementsLayoutElement?.sort_order + 1 :  this.model.certificateElementsArray.length
  }

  protected get selectedElementInInGrid(): boolean{
    const selectedCertificateElement = this.model.selectedCertificateElement
    return !!selectedCertificateElement && !selectedCertificateElement.isLayoutElementContainer && selectedCertificateElement.layoutElementContainer  === this.model
  }

  protected get positionValueIfNonePassedIn(): number{
    //Either is added after the selected section/section that contains selected element or at the end of the array
    return  this.selectedElementInInGrid ? this.model.selectedCertificateElement.sort_order + 1:  this.model.certificateElementsArray.length -1
  }
}